module.exports = __webpack_public_path__ + "img/badge_6.2cbe7ebf.png";